/**
 * CUSTOM COMPONENT REGISTRY
 *
 * This registry maps string identifiers to actual React components for
 * dynamic component resolution at runtime. It serves as the bridge between
 * JSON configuration and actual React components for this specific report type.
 *
 * DESIGN BENEFITS:
 * - Report-specific: Each report type can have its own component registry
 * - Co-located: Registry lives alongside the injection config for better organization
 * - Modular: Changes to custom components don't affect other report types
 * - JSON-driven: Configurations reference components through string identifiers
 * - Type-safe: Import errors caught at build time, not runtime
 * - Versatile: Works with the reusable ReportDocument component
 *
 * HOW TO ADD NEW CUSTOM COMPONENTS:
 * 1. Create your custom component in ./custom_report_components/
 * 2. Import it in this file
 * 3. Add an entry to CUSTOM_COMPONENT_REGISTRY with a unique string identifier
 * 4. Use the identifier in injectionConfig.json
 *
 * EXAMPLE:
 * import MyCustomChart from './custom_report_components/MyCustomChart';
 *
 * export const CUSTOM_COMPONENT_REGISTRY = {
 *     'my-chart': MyCustomChart,
 *     'drivers-list': DriversListComponent,
 * };
 */

import React from 'react'

// Custom Component Registry
// Maps type strings to React components for dynamic injection in reports

import DriversListComponent from './custom_report_components/DriversListComponent'
import ScenarioReportNumbers from './custom_report_components/ScenarioReportNumbers'

// Define the component registry type
export type CustomComponentRegistry = {
  [key: string]: React.ComponentType<any>
}

// Component mapping for custom components - add new custom components here
export const CUSTOM_COMPONENT_REGISTRY: CustomComponentRegistry = {
  'drivers-list': DriversListComponent,
  'scenario-numbers': ScenarioReportNumbers,

  // Add more custom components as needed
  // 'scenario-analysis': ScenarioAnalysisComponent,
  // 'custom-metrics': CustomMetricsComponent,
}
